import { gql } from '@apollo/client';
import { PAYMENT_METHOD_FRAGMENT } from '~/services/fetch-existing-payment-methods/fetch-existing-payment-method.queries';

export const UPDATE_PLAN_PAYMENT_METHOD = gql`
  mutation Flex_UpdatePlanPaymentMethod($input: SetPaymentMethodInput!) {
    setPaymentMethod(input: $input) {
      id
      paymentMethod {
        ...PaymentMethodData
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;
